'use strict';

import api from '@/assets/js/api/index';

export default {
    getData(payload) {
        let { to, config } = payload || {};
        return new Promise((resolve, reject) => {
            api.get({ url: `${to || ''}`, config })
                .then((response) => {
                    // console.log(response);
                    resolve(response.data);
                })
                .catch((error) => {
                    // console.log(error);
                    reject(error);
                });
        });
    },
    postData(payload) {
        let { to, data, config } = payload || {};
        return new Promise((resolve, reject) => {
            api.post({ url: `${to || ''}`, data, config })
                .then((response) => {
                    // console.log(response);
                    if (config && config.addHeader) {
                        resolve(response);
                    }

                    resolve(response.data);
                })
                .catch((error) => {
                    // console.log(error);
                    reject(error);
                });
        });
    },
    putData(payload) {
        let { to, data, config } = payload || {};
        return new Promise((resolve, reject) => {
            api.put({ url: `${to || ''}`, data, config })
                .then((response) => {
                    // console.log(response);
                    resolve(response.data);
                })
                .catch((error) => {
                    // console.log(error);
                    reject(error);
                });
        });
    },
    deleteData(payload) {
        let { to, config } = payload || {};
        return new Promise((resolve, reject) => {
            api.delete({ url: `${to || ''}`, config })
                .then((response) => {
                    // console.log(response);
                    resolve(response.data);
                })
                .catch((error) => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};
